import React, { Component } from 'react';
import i18n from 'react-intl-universal';
import styles from './EmptyContent.scss';

export default class EmptyContent extends Component {
  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <div className={styles['no-content']}>
        <span>{i18n.get('app.name')}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmptyContent/EmptyContent.js